<app-tools-catalogue-menu
  [breadcrumbLinks]="breadcrumbLinks"
></app-tools-catalogue-menu>

<div class="tool-wrapper" *ngIf="metricUseCase">
  <div class="container mb-6 m-t-rel">
    <div class="columns">
      <div class="column is-8 pt-0">
        <div class="flex space-between align-center">
          <div
            class="flex align-center space-between post-meta-sharing-box is-fullwidth"
          >
            <h1 class="title is-2 m-t-0 m-b-0">
              {{ metricUseCase.name }}
            </h1>

            <div>
              <app-social-share
                [title]="metricUseCase.name"
                [darkTheme]="false"
              ></app-social-share>
            </div>
          </div>
        </div>
        <ng-container *ngIf="metricUseCase.metrics.length">
          <div
            class="block block--link has-background-white-ter is-size-6 m-b-gutter mt-3"
          >
            <div class="py-5">
              <strong class="is-bold m-r-md">Metrics concerned:</strong>
              <ng-container
                *ngFor="let metric of metricUseCase.metrics; let last = last"
              >
                <a [routerLink]="['/catalogue', 'metrics', metric.slug]">{{
                  metric.name
                }}</a>
                <ng-container *ngIf="!last">,&nbsp;</ng-container>
              </ng-container>
            </div>
          </div>
        </ng-container>
        <div
          class="field is-grouped is-grouped-multiline"
          *ngIf="
            metricUseCase.mainReferenceLink ||
            metricUseCase.huggingFaceLink ||
            metricUseCase.githubLink ||
            metricUseCase.websiteLink
          "
        >
          <div class="control" *ngIf="metricUseCase.mainReferenceLink">
            <a
              class="tags has-addons ghost"
              [href]="metricUseCase.mainReferenceLink"
              target="_blank"
            >
              <span class="tag is-dark is-flex is-align-items-center">
                <i class="fas fa-globe"></i
              ></span>
              <span class="tag is-white-bis">Main Reference</span>
            </a>
          </div>
          <div class="control" *ngIf="metricUseCase.huggingFaceLink">
            <a
              class="tags has-addons ghost"
              [href]="metricUseCase.huggingFaceLink"
              target="_blank"
            >
              <span class="tag is-small is-dark is-flex is-align-items-center">
                <i class="far fa-laugh-beam"></i>
              </span>
              <span class="tag is-small is-white-bis">Hugging Face</span>
            </a>
          </div>
          <div class="control" *ngIf="metricUseCase.githubLink">
            <a
              class="tags has-addons ghost"
              [href]="metricUseCase.githubLink"
              target="_blank"
            >
              <span class="tag is-dark is-flex is-align-items-center">
                <i class="fab fa-github"></i
              ></span>
              <span class="tag is-white-bis">Github</span>
            </a>
          </div>
          <div class="control" *ngIf="metricUseCase.websiteLink">
            <a
              class="tags has-addons ghost"
              [href]="metricUseCase.websiteLink"
              target="_blank"
            >
              <span class="tag is-dark is-flex is-align-items-center">
                <i class="fas fa-globe"></i
              ></span>
              <span class="tag is-white-bis">Website</span>
            </a>
          </div>
        </div>

        <div class="full-width" [innerHTML]="metricUseCase.content"></div>
      </div>

      <!-- Sidebar Taxonomies -->
      <div class="column is-4 pb-0">
        <div class="card bg-white taxonomy-relation-list">
          <h3 class="is-size-5 mt-6 mb-5">About the metric use case</h3>
          <div class="is-size-7">
            <div class="block block--link">
              <p class="my-0">
                You can click on the links to see the associated metric use
                cases
              </p>
            </div>

            <ng-container *ngFor="let taxonomy of sidebarTaxonomies">
              <ng-container
                *ngIf="
                  metricUseCase[taxonomy.propName] &&
                  metricUseCase[taxonomy.propName].length
                "
              >
                <hr class="has-background-white-bis" />
                <div
                  class="is-flex is-align-items-flex-start is-justify-content-center"
                >
                  <p class="my-0 is-bold">{{ taxonomy.label }}:</p>
                  <ul class="my-0 ml-0 no-lst">
                    <li *ngFor="let item of metricUseCase[taxonomy.propName]">
                      <a
                        *ngIf="taxonomy.queryParamName"
                        (click)="
                          goToFilteredList(taxonomy.queryParamName, item.id)
                        "
                        (keydown)="
                          goToFilteredList(taxonomy.queryParamName, item.id)
                        "
                        tabindex="0"
                      >
                        {{ item.name }}
                      </a>
                    </li>
                  </ul>
                </div>
              </ng-container>
            </ng-container>
            <hr
              *ngIf="metricUseCase.tags?.length"
              class="has-background-white-bis"
            />
            <div
              class="is-flex is-align-items-flex-start is-justify-content-center"
              *ngIf="metricUseCase.tags?.length"
            >
              <p class="my-0 is-bold">Tags:</p>
              <ul class="my-0 ml-0 no-lst">
                <li *ngFor="let tag of metricUseCase.tags">
                  <span>{{ tag.name }}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <p class="has-text-right mt-4 mb-0">
          <a
            (click)="showReportMetricUseCaseModal = true"
            (keydown)="showReportMetricUseCaseModal = true"
            tabindex="0"
            class="flag-link has-text-primary is-size-6 no-deco"
          >
            <i class="icon icon-Assignedtomyself1 mr-2"></i>
            <span>Modify this use case</span>
          </a>
        </p>
      </div>
    </div>
  </div>
</div>

<!-- Report tool modal-->
<app-flag-modal
  *ngIf="showReportMetricUseCaseModal"
  [resourceId]="metricUseCase.id"
  [resourceType]="ResourceSlug.MetricUseCases"
  (modalClosed)="showReportMetricUseCaseModal = false"
></app-flag-modal>

<app-tools-catalogue-disclaimer></app-tools-catalogue-disclaimer>
